var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"title":"Tabla de muestras"},on:{"hidden":_vm.onHidden},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-table',{attrs:{"items":_vm.muestras,"fields":_vm.fields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }